import { Injectable, signal, inject } from '@angular/core';
import { OAuthService, TokenResponse } from 'angular-oauth2-oidc';
import { Router } from '@angular/router';
import { UnsubscribeBase } from '@core-utils';
import { from, Observable } from 'rxjs';
import { KeycloakUserParamsDto } from '@shared/data-access';
import { LOCAL_STORAGE, PAGE_ROUTES } from '@shared/core-data';

@Injectable()
export class AuthService extends UnsubscribeBase {
  private oauthService = inject(OAuthService);
  private router = inject(Router);

  isLoading = signal<boolean>(false);

  initLoginFlow(params?: KeycloakUserParamsDto) {
    this.oauthService.initLoginFlow('', params);
  }

  refreshToken(): Observable<TokenResponse> {
    return from(this.oauthService.refreshToken());
  }

  updateExpireToken() {
    this.addSubscription = this.oauthService.events.subscribe((e) => {
      if (e.type === 'token_received') {
        this.hasValidAccessToken();
      }
      if (
        e.type === 'token_refresh_error' ||
        e.type === 'invalid_nonce_in_state'
      ) {
        this.initLoginFlow();
      }
    });
  }

  refreshTokenAfterSleep() {
    document.addEventListener('visibilitychange', async () => {
      if (
        document.visibilityState === 'visible' &&
        !this.hasValidAccessToken() &&
        !this.router.url.split('/').includes(PAGE_ROUTES.AUTH)
      ) {
        this.oauthService.initLoginFlow();
      }
    });
  }

  hasValidAccessToken(): boolean {
    const token = this.oauthService.getAccessToken();
    if (!token) {
      return false;
    }

    const expirationTime = Number(
      sessionStorage.getItem(LOCAL_STORAGE.TOKEN_EXPIRES_AT),
    );
    const currentTime = Number(
      sessionStorage.getItem(LOCAL_STORAGE.TOKEN_STORED_AT),
    );

    return currentTime < expirationTime;
  }

  login() {
    this.oauthService.initLoginFlow();
  }

  get accessToken(): string {
    return this.oauthService.getAccessToken();
  }

  logout() {
    localStorage.clear();
    this.oauthService.logOut();
  }
}
